import { parseISO, isAfter, isEqual } from "date-fns";

export function handleNewAssistantFlowFlag(organization) {
  let showNewAssistantFlow = false;

  const createdDate = organization?.createdDate;
  const parsedCreatedDate = parseISO(createdDate);
  const targetDate = new Date("2025-06-12");

  const isAfterOrEqual =
    isAfter(parsedCreatedDate, targetDate) || isEqual(parsedCreatedDate, targetDate);

  const isPronto = organization?.id == "-Kr5CZlS7jHaD5WfLalL";

  showNewAssistantFlow = isAfterOrEqual || isPronto;

  return showNewAssistantFlow;
}
